import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { safeFormat } from '../../utils/timeFormatters';

const TwilightTimesPanel = ({ additionalInfo, coordinates, timezone }) => {
  if (!additionalInfo) return null;

  // Use IANA timezone for accurate formatting
  const formatTimeForLocation = (date) => {
    return safeFormat(date, coordinates, timezone);
  };
  
  return (
    <div>
      <div className="grid grid-cols-2 gap-2 text-sm">
        <div className="flex items-center">
          <Sun size={14} className="text-yellow-300 mr-1" />
          <span className="text-white/70">Civil Dawn:</span>
        </div>
        <span className="text-white">
          {formatTimeForLocation(additionalInfo?.civilTwilight?.begin)}
        </span>
        
        <div className="flex items-center">
          <Moon size={14} className="text-gray-300 mr-1" />
          <span className="text-white/70">Civil Dusk:</span>
        </div>
        <span className="text-white">
          {formatTimeForLocation(additionalInfo?.civilTwilight?.end)}
        </span>
        
        <div className="flex items-center">
          <span className="text-white/70">Nautical Dawn:</span>
        </div>
        <span className="text-white">
          {formatTimeForLocation(additionalInfo?.nauticalTwilight?.begin)}
        </span>
        
        <div className="flex items-center">
          <span className="text-white/70">Nautical Dusk:</span>
        </div>
        <span className="text-white">
          {formatTimeForLocation(additionalInfo?.nauticalTwilight?.end)}
        </span>
        
        <div className="flex items-center">
          <span className="text-white/70">Astronomical Dawn:</span>
        </div>
        <span className="text-white">
          {formatTimeForLocation(additionalInfo?.astronomicalTwilight?.begin)}
        </span>
        
        <div className="flex items-center">
          <span className="text-white/70">Astronomical Dusk:</span>
        </div>
        <span className="text-white">
          {formatTimeForLocation(additionalInfo?.astronomicalTwilight?.end)}
        </span>
      </div>
    </div>
  );
};

export default TwilightTimesPanel;